export enum TaskPrivacyEnum {
  by_me = 'by_me',
  my_team = 'my_team',
  me = 'me',
}
